var exports = {
  "pW": "DiscoveryBannerTint.module__bannerTintViolet___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "wi": "DiscoveryBannerTint.module__bannerTintBlue___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "gp": "DiscoveryBannerTint.module__bannerTintTeal___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "ZQ": "DiscoveryBannerTint.module__bannerTintGreen___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "j8": "DiscoveryBannerTint.module__bannerTintLime___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "LJ": "DiscoveryBannerTint.module__bannerTintAmber___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "zg": "DiscoveryBannerTint.module__bannerTintCoral___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "zv": "DiscoveryBannerTint.module__bannerTintRose___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "$B": "DiscoveryBannerTint.module__bannerTintMagenta___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
  "KS": "DiscoveryBannerTint.module__bannerTintIndigo___ZmJ5bj" + " " + "DiscoveryBannerTint.module__bannerTint___ZmJ5bj",
};

module.exports = exports;
